<!--
 * @Descripttion:
 * @version:
 * @Author: renqiang_hu
 * @Date: 2022-12-05 17:03:31
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2022-12-06 19:19:18
 * @FilePath: \wanguo_web\common_web\src\views\archiveManager\leaseContractDetail.vue
-->
<template>
  <div class="leaseContractDetail">
    <div class="head">
      <i class="i1"></i><i class="i2"></i>
      <div class="con">{{ name }}</div>
      <div>
        <!-- <el-button type="success" size="mini" @click="setval">{{$t('archiveManagerleaseDetail.edit')}}</el-button> -->
        <el-button type="primary" size="mini" @click="goblack">{{$t('applyChildDetail.return')}}</el-button>

      </div>
    </div>
    <div class="form">
      <avue-crud :option="option" :data="data" :search.sync="search" :table-loading="loading" ref="crud" v-model="form"
       :page.sync="page" @search-change="searchChange" @search-reset="searchReset"
        @current-change="currentChange" @size-change="sizeChange" @refresh-change="refreshChange" @on-load="onLoad">



      </avue-crud>
    </div>

  </div>
</template>
<script>
import {
  shopLeaseContract
} from "@/api/archive.js";
export default {
  data() {
    return {
      form: {},
      search: {
      },
      selectionList: [],
      query: {},
      loading: false,

      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0
      },
      option: {
        columnSort: true,
        height: 'auto',
        calcHeight: 20,
        tip: false,
        header:false,
        pagetips: true,
        searchShow: true,
        searchMenuSpan: 6,
        columnBtn: false,
        refreshBtn: false,
        border: true,
        index: true,
        viewBtn:true,
        delBtn: false,
        editBtn: false,
        selection: false,
        addBtn: false,

        searchLabelWidth: 80,
        align: 'center',
        dialogClickModal: false,
        column: [
          {
            label: this.$t('dianPuZhaoPian'),
            prop: "shopPhoto",
            type: 'img',
            viewDisplay:false
          },
          {

            label: this.$t('applyDeviceCheck.storeName'),
            prop: "shopName",
          },

          {
            label: this.$t('applyChildDetail.storeCode'),
            prop: "shopCode",
          },
          {
            search: true,
            label: this.$t('heTongBianMa'),
            prop: "contractCode",

          },
          {
            label: this.$t('heTongLeiXing'),
            prop: "typeName",
          },
          {
            label: this.$t('shouFuJinE'),
            prop: "downPayment",
            slot:true,
            hide: true,
            display:true
          },
          {
            label: this.$t('fenQiFuKuan'),
            prop: "installmentAmount",
            hide: true,
            display: true
          },
          {
            label: this.$t('applyChildDetail.rentalDeposit'),
            prop: "leaseDeposit",
            hide: true,
            display: true
          },
        ],
      },
      data: [],
    };
  },
  props: {
    id: {
      type: [Number,String],
    },
    name: {
      type:String
    }

  },
  watch: {
    'form.type'(val) {
      const downPayment = this.findObject(this.option.column, "downPayment");
      const installmentAmount = this.findObject(this.option.column, "installmentAmount");
      const leaseDeposit = this.findObject(this.option.column, "leaseDeposit");
      if (val==1){
        downPayment.display = false
        installmentAmount.display = false
        leaseDeposit.display = true
      } else {
        downPayment.display = true
        installmentAmount.display = true
        leaseDeposit.display = false
      }

    }
  },
  computed:{

  },
  mounted() {

  },
  methods: {

    goblack() {
      this.$emit("goblack");
    },
    searchReset() {
      this.query = {};

      this.getcalculate()
      this.onLoad(this.page);
    },
    searchChange(params, done) {
      this.query = params;
      this.page.currentPage = 1;
      this.onLoad(this.page, params);

      done();
    },
    selectionChange(list) {
      this.selectionList = list;
    },

    currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    refreshChange() {
      this.onLoad(this.page, this.query);
    },
    onLoad(page, params = { }) {
      this.loading = true;
      let obj = {
        current: this.page.currentPage,
        size: this.page.pageSize,
        ...Object.assign(params, this.query),
        queryType: 'shopLeaseContractList', shopCode: this.id
      }
      shopLeaseContract(obj).then(res => {
        const data = res.data.data;
        this.page.total = data.total;
        data.records.map(v => {
          if (v.downPayment) {
            v.downPayment = v.downPayment+ v.unit
          }
          if (v.leaseDeposit) {
            v.leaseDeposit = v.leaseDeposit + v.unit
          }
          if (v.installmentAmount) {
            v.installmentAmount = v.installmentAmount + v.unit
          }
        })
        this.data = data.records;
        this.loading = false;

      });
    },
  },
};
</script>
<style lang="scss" >
.leaseContractDetail {
  background: #fff;
  padding: 0 20px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  align-items: center;
  .flexview {
    display: flex;
    align-items:center;
    justify-content: center;
  }
  .head {
    display: flex;
    width: 100%;
    flex: 1;
    margin-top: 10px;
    align-items: center;
    .i1 {
      width: 4px;
      height: 18px;
      background: #50c4cb;
      border-radius: 1px;
      margin-right: 2px;
      display: inline-block;
    }
    .i2 {
      width: 2px;
      height: 18px;
      background: #50c4cb;
      border-radius: 1px;
      display: inline-block;
    }
    .con {
      flex: 1;
      font-size: 18px;
      color: #333;
      font-weight: bold;
      margin-left: 10px;
    }
  }
     .form {
       margin-top: 10px;
       width: 100%;
       height: 100%;}

}
</style>
